import styled, { css, keyframes } from 'styled-components';
import {
  black,
  border1,
  exactWhite,
  formColor1,
  green,
} from '../../../utils/style/colors';

const gradientShift = keyframes`
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
`;

const geminiPulse = keyframes`
  0%, 100% { transform: scale(1) rotate(0deg); }
  50% { transform: scale(1.2) rotate(180deg); }
`;

const dotBounce = keyframes`
  0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
  40% { transform: scale(1); opacity: 1; }
`;

const shimmer = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(200%); }
`;

export const IndexBadge = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 10rem;
  background-color: 'var(--exact-white)';
  color: ${formColor1};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: ${border1};
`;

export const OptionalTitle = styled('span')`
  color: grey;
  font-size: 9pt;
  word-break: break-word;
  flex-shrink: 0;
`;
export const TitleWrapper = styled('span')`
  display: flex;
  align-items: center;
  padding: 0.8rem 1rem 0.25rem;
  //background-color: #f2f5f7;
  // margin-bottom: 0.8rem;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  color: ${black};
`;

export const QuestionTitle = styled('span')`
  flex: 1;
  font-weight: 400;
  gap: 0.5rem;
  word-break: break-word;
  line-height: 1.8;
  font-size: 1rem;
  padding-inline-end: 1rem;
  display: flex;
  justify-content: space-between;
`;

export const QuestionHint = styled('div')`
  margin-left: 1.5rem;
`;

export const ChevronWrapper = styled('div')`
  background: var(--exact-white);
  border-radius: 2rem;
  width: 1.5rem;
  height: 1.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const ChevronButton = styled('div')`
  cursor: pointer;
  user-select: none;
  background-color: ${green};
  display: inline-flex;
  align-items: center;
  padding: 0.3rem;
  border-radius: 2rem;
  margin-right: 10px;
`;

export const ChevronText = styled('span')`
  margin: 0 0.5rem;
  color: ${exactWhite}; /* same as chevron color fill */
`;

export const GenerateContentViaAIButton = styled('button')<{
  generating?: boolean;
}>`
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.75rem;
  border: none;
  border-radius: 2rem;
  cursor: ${(props) => (props.generating ? 'wait' : 'pointer')};
  font-size: inherit;
  font-family: inherit;
  color: ${exactWhite};
  margin-right: 10px;
  white-space: nowrap;
  transition:
    opacity 0.2s ease,
    box-shadow 0.2s ease;

  background: ${(props) =>
    props.generating
      ? 'linear-gradient(96deg, rgb(66, 97, 253) 0%, rgb(244, 75, 109) 50%, rgb(145, 104, 192) 100%)'
      : green};
  background-size: ${(props) => (props.generating ? '200% 200%' : '100% 100%')};

  ${(props) =>
    props.generating &&
    css`
      animation: ${gradientShift} 2.5s ease infinite;
      box-shadow: 0 0 12px rgba(66, 97, 253, 0.45);
    `}

  &:disabled {
    opacity: 0.95;
  }

  &:not(:disabled):hover {
    filter: brightness(1.05);
  }

  ${(props) =>
    props.generating &&
    css`
      &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(
          90deg,
          transparent 0%,
          rgba(255, 255, 255, 0.25) 50%,
          transparent 100%
        );
        animation: ${shimmer} 1.8s infinite;
      }
    `}
`;

export const GeminiIconWrapper = styled('span')<{ generating?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  z-index: 1;

  ${(props) =>
    props.generating &&
    css`
      animation: ${geminiPulse} 1.4s ease-in-out infinite;
    `}
`;

export const GenerateContentViaAiLabel = styled('span')`
  z-index: 1;
`;

export const GeneratingDots = styled('span')`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  z-index: 1;

  & span {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: ${exactWhite};
    animation: ${dotBounce} 1.2s infinite ease-in-out;

    &:nth-child(1) {
      animation-delay: 0s;
    }
    &:nth-child(2) {
      animation-delay: 0.15s;
    }
    &:nth-child(3) {
      animation-delay: 0.3s;
    }
  }
`;
